import React, { Component } from "react";

// @TODO: Invoke a report to audit logs

export default class FourOhThree extends Component {
  render() {
    return (
      <div>
        <h3>Permission denied!</h3>
        <p>
          Please contact your system administrator. This incident will be
          reported.
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/library/pages/403.js